import { useState, useEffect, useCallback, useMemo } from "react";
import { useProjectApi } from "../../hooks/useProjectApi";
import { useResourceApi } from "../../hooks/useResourceApi";

export const useAllProjectHistoryViewModel = (projectId) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { getProjectHistory } = useProjectApi();
  const {
    getResources,
    cacheOperations: { readResources, writeResources },
  } = useResourceApi();

  const fetchProjectHistory = useCallback(async () => {
    if (!loading) setLoading(true);
    try {
      const [result, resourceResult] = await Promise.all([
        getProjectHistory(projectId),
        getResources(),
      ]);
      if (!result.success || !resourceResult.success) {
        throw new Error("Failed to fetch required data");
      }
      setHistory(result.data);

      if (resourceResult.data?.GetResources) {
        writeResources(resourceResult.data.GetResources);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [projectId, getProjectHistory, getResources, writeResources]);

  useEffect(() => {
    fetchProjectHistory();
  }, []);

  return {
    history,
    loading: loading,
    error,
    refetch: fetchProjectHistory,
  };
};
